export default {
  addOns: 'الإضافات',
  addToCart: 'إضافة إلى السلة',
  availability: 'التوفر',
  availabilityDaySelector: 'محدد يوم التوفر',
  capacity: 'السعة',
  checkout: 'الدفع',
  continue: 'متابعة',
  dateRangeSelector: 'محدد نطاق التاريخ',
  findAvailability: 'البحث عن التوفر',
  from: 'من',
  loading: 'جارٍ التحميل',
  night: 'ليلة',
  nights: 'ليالٍ',
  noAvailableSessionsForSelectedDates:
    'لا تتوفر جلسات في بعض التواريخ التي اخترتها. يرجى اختيار تواريخ مختلفة.',
  noAvailableSessionsOnThisDate: 'لا توجد جلسات متاحة في هذا التاريخ',
  noCollectionFound: 'لم يتم العثور على المجموعة!',
  noData: 'لا توجد بيانات!',
  noGroupAvailableOnThisDateAndTime:
    'لا يوجد {{groupTitle}} متاح في هذا التاريخ والوقت',
  noResourceGroupFound: 'لم يتم العثور على مجموعة موارد!',
  people: 'أشخاص',
  person: 'شخص',
  priceTierRadioGroup: 'محدد فئة السعر',
  questions: 'الأسئلة',
  reserve: 'حجز',
  reserveNow: 'احجز الآن',
  select: 'اختيار',
  selectTime: 'اختر الوقت',
  session: 'الجلسة',
  showLess: 'عرض أقل',
  showMore: 'عرض المزيد',
  tier: 'الفئة',
  time: 'الوقت',
  total: 'الإجمالي',
  unavailable: 'غير متاح',
  viewDetails: 'عرض التفاصيل',
  whatsIncluded: 'ما يشمله',
  startTime: 'وقت البدء',
  duration: 'المدة',
  lengthOfStay: 'مدة الإقامة',
  startDate: 'تاريخ البدء',
  endDate: 'تاريخ الانتهاء',
  selectDates: 'اختر التواريخ',
  more: 'المزيد',
  selectStartTime: 'اختر وقت البدء',
  endTime: 'وقت الانتهاء',
  selectEndTime: 'اختر وقت الانتهاء',
  morning: 'صباحًا',
  afternoon: 'بعد الظهر',
  save: 'حفظ',
  selectDuration: 'اختر المدة',
  forLength: 'لمدة {{length}}',
  moreDates: '{{count}} أخرى',
  addDate: 'أضف تاريخًا',
  start: 'البدء',
  end: 'الانتهاء',
  pickupFrom: 'الاستلام من',
  returnBy: 'الإرجاع قبل',
  day: 'يوم',
  days: 'أيام',
  hour: 'ساعة',
  hours: 'ساعات',
};
